/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Functions from store
import { getClients } from "../../store";

// Date-fns
import { format, addMinutes } from "date-fns";

// Cookies
import Cookies from "universal-cookie";
import { Backdrop, CircularProgress } from "@mui/material";
const cookies = new Cookies();

const Clients = ({ getClients, getClientsReducer }) => {
  let userData = cookies.get("loginDetailsForSupport");

  let token = userData?.token;

  useEffect(() => {
    getClients(token);
  }, []);

  const [state, setState] = useState({
    columns: [
      { Header: "Client Name", accessor: "clientName", align: "left" },
      { Header: "Contact Person", accessor: "contactPerson", align: "left" },
      { Header: "Client Email", accessor: "pEmail", align: "left" },
      { Header: "Open Tickets", accessor: "openTickets", align: "left" },
      {
        Header: "Start Date",
        accessor: "startDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset()
                ),
                "dd/MM/yyyy hh:mm aaa"
              )
            : "";
        },
      },
      {
        Header: "Expiry Date",
        accessor: "endDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset()
                ),
                "dd/MM/yyyy hh:mm aaa"
              )
            : "";
        },
      },
      {
        Header: "Subscription Status",
        accessor: "subscriptionStatus",
        align: "left",
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempIssues = [];
    let issuesData = getClientsReducer.clients ? getClientsReducer.clients : [];
    setLoading(getClientsReducer.loading);
    issuesData.map((issue) => {
      const startDate = new Date(issue?.startDate);
      const endtDate = new Date(issue?.endDate);
      const singleIssue = {
        privateKey: issue.id,
        key: issue.key,
        clientName: issue.companyName,
        pEmail: issue.pEmail,
        contactPerson: issue.pName,
        openTickets: issue.openTickets,
        startDate: issue.startDate,
        endDate: issue.endDate,
        subscriptionStatus: (
          <button
            className={
              (issue.subscriptionStatus === 0 && `subscriptionStatus-error`) ||
              (issue.subscriptionStatus === 1 &&
                `subscriptionStatus-warning`) ||
              (issue.subscriptionStatus === 2 && `subscriptionStatus-success`)
            }
            style={{ width: "5.5rem" }}
          >
            {issue.subscriptionDays}
          </button>
        ),
      };
      tempIssues.push(singleIssue);
    });
    setState({ ...state, rows: tempIssues });
  }, [getClientsReducer]);

  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={0} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    canSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        {loading && (
          <Backdrop
            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <Footer />
      </DashboardLayout>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    reportedTicketsReducer: state.reportedTicketsReducer,
    getClientsReducer: state.getClientsReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getClients: (token) => dispatch(getClients(token)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Clients);
